import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ToolsModule = lazy(loadModule);

export default ToolsModule;
